import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

export default function PackagesSoloPublished() {
  const params = useParams();
  const { nameUrl } = params;

  useEffect(() => {
    console.log("name: ", nameUrl);
  });

  return <div>PackagesSoloPublished</div>;
}
